import {css, StyleSheet} from 'aphrodite';
import React, {useCallback} from 'react';

import {DocumentStatus, WorksheetStepDocumentSelection} from 'notebook/worksheets/WorksheetConstants';
import {useValidatedWorksheetContext} from 'notebook/worksheets/WorksheetContext';
import {STEP_SELECTOR_SIDEBAR_WIDTH} from 'procedures/shared-components/step-config/step-nav/StepNavigationDesignConstants';
import ExecutionStepSelectorSidebar from 'procedures/worksheets/ExecutionStepSelectorSidebar';
import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY} from 'ui-library/Colors';

interface WorksheetSidepanelProps {
  selectedStep: WorksheetStepDocumentSelection;
  onSetSelectedStep: (stepSelection: WorksheetStepDocumentSelection) => void;
  isWorksheetPending: boolean;
  isWorksheetInReview?: boolean;
}

export default function WorksheetSidepanel({
  selectedStep,
  onSetSelectedStep,
  isWorksheetPending,
  isWorksheetInReview,
}: WorksheetSidepanelProps): JSX.Element {
  const {
    worksheet: {worksheetStepGroups},
  } = useValidatedWorksheetContext();

  const onClick = useCallback(
    (groupIndex: number, stepIndex: number): void => {
      const documentId = worksheetStepGroups[groupIndex].worksheetSteps[stepIndex].document.id;
      onSetSelectedStep({
        stepGroupIndex: groupIndex,
        stepIndex,
        document: {id: documentId, status: DocumentStatus.LOADED},
      });
    },
    [onSetSelectedStep, worksheetStepGroups]
  );

  const onAddStepCompleted = useCallback(
    (stepGroupIndex: number, stepIndex: number): void => {
      onSetSelectedStep({
        stepGroupIndex,
        stepIndex,
        document: {status: DocumentStatus.LOADING},
      });
    },
    [onSetSelectedStep]
  );
  return (
    <div
      className={css(styles.sidepanel)}
      {...getTestProps({
        component: 'WorksheetSidepanel',
        element: 'root',
      })}
    >
      <ExecutionStepSelectorSidebar
        setSelectedStep={onClick}
        onAddStepCompleted={onAddStepCompleted}
        isWorksheetLocked={isWorksheetPending || Boolean(isWorksheetInReview)}
        selectedStep={selectedStep}
        isWorksheetInReview={isWorksheetInReview}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  sidepanel: {
    borderRight: `1px solid ${GRAY}`,
    overflowY: 'auto',
    width: `${STEP_SELECTOR_SIDEBAR_WIDTH}px`,
  },
});
